import { fg } from '@atlassian/jira-feature-gating';

const WivSsrForgeStoreHydration = {
	get(): boolean {
		return fg('wiv-ssr-forge-store-hydration');
	},
};

export default WivSsrForgeStoreHydration;
